"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Icon = function (_PureComponent) {
  (0, _inherits2["default"])(Icon, _PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2["default"])(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Icon, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setState({
        color: this.props.color
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          handleClick = _this$props.handleClick,
          height = _this$props.height,
          icon = _this$props.icon,
          size = _this$props.size,
          testId = _this$props.testId,
          viewBox = _this$props.viewBox,
          width = _this$props.width,
          fillRule = _this$props.fillRule;
      return _react["default"].createElement("div", {
        className: className,
        "data-test-id": testId,
        onClick: handleClick,
        role: "button"
      }, _react["default"].createElement("svg", {
        width: "".concat(size || width, "px"),
        height: "".concat(size || height, "px"),
        viewBox: "".concat(viewBox)
      }, _react["default"].createElement("path", {
        fillRule: fillRule,
        fill: color,
        d: icon
      })));
    }
  }]);
  return Icon;
}(_react.PureComponent);

Icon.propTypes = {
  color: _propTypes["default"].string,
  className: _propTypes["default"].string,
  handleClick: _propTypes["default"].func,
  height: _propTypes["default"].number,
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].number,
  testId: _propTypes["default"].string,
  viewBox: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  fillRule: _propTypes["default"].string
};
Icon.defaultProps = {
  color: _palette.palette.bobBlack,
  colorHover: _palette.palette.bobBlack,
  handleClick: function handleClick() {},
  height: 24,
  size: undefined,
  testId: undefined,
  viewBox: '0 0 1024 1024',
  width: 24,
  fillRule: undefined
};
var _default = Icon;
exports["default"] = _default;